import { FormattedMessage } from 'react-intl';
import { mapValues } from 'lodash';

import { PasswordField, TextField } from '@app/components';
import { authMessages, sharedMessages } from '@app/translations';

export const fieldDescriptions = mapValues(
  {
    'BASIC/UNIQUE-ID+NAME': {
      nameField: (
        <FormattedMessage id="login.uniqueID" defaultMessage="Unique ID" />
      ),
      passwordField: <FormattedMessage {...authMessages.lastName} />,
    },
    'BASIC/BARCODE+NAME': {
      nameField: <FormattedMessage {...sharedMessages.barcode} />,
      passwordField: <FormattedMessage {...authMessages.lastName} />,
    },
    'BASIC/BARCODE+PASSWORD': {
      nameField: <FormattedMessage {...sharedMessages.barcode} />,
      passwordField: <FormattedMessage {...authMessages.password} />,
    },
    'BASIC/BARCODE+PIN': {
      nameField: <FormattedMessage {...sharedMessages.barcode} />,
      passwordField: <FormattedMessage {...sharedMessages.pin} />,
    },
  },
  ({ nameField, passwordField }) => [
    { label: nameField, name: 'barcode', component: TextField },
    {
      label: passwordField,
      name: 'pin',
      component: PasswordField,
    },
  ]
);

export const usernamePasswordFieldsDescription = [
  {
    label: <FormattedMessage {...authMessages.username} />,
    name: 'username',
    component: TextField,
  },
  {
    label: <FormattedMessage {...authMessages.password} />,
    name: 'password',
    component: PasswordField,
  },
];
